/* eslint-disable no-shadow */
import { get } from '@utils/api';

/**
 *
 * @param {string} lookupIds
 * @param {string | null} zipCode
 * @returns {string}
 */
const buildUrl = (lookupIds, zipCode) => `/xapi/digital/v1/product/bigticket/check/${lookupIds}?zipcode=${zipCode}`;

/**
 * @param {import('./availabilityBigTicketStore').AvailabilityBigTicketStoreState} state
 * @param { string } objectKey
 * @returns {boolean}
 */
const isCached = (state, objectKey) => !!state.data[objectKey];

export function state() {
  return {
    data: {},
    zipCode: '',
    zipcodeSlideoutShown: false,
    previouslyFocusedElement: false,
    activeSlideout: null,
  };
}
export const mutations = {
  /**
   *
   * @param {import('./availabilityBigTicketStore').AvailabilityBigTicketStoreState} state
   * @param {Object} param1
   * @param {*} param1.result
   * @param {string} param1.objectKey

   */
  setData(state, { result, objectKey }) {
    state.data[objectKey] = result;
  },

  /**
   *
   * @param {import('./availabilityBigTicketStore').AvailabilityBigTicketStoreState} state
   * @param {string} zipCode
   */
  setZip(state, zipCode) {
    state.zipCode = zipCode;
  },
  /**
   *
   * @param {import('./availabilityBigTicketStore').AvailabilityBigTicketStoreState} state
   * @param {boolean} value
   */
  setZipCodeSlideoutShown(state, value) {
    state.zipcodeSlideoutShown = value;
  },
  /**
   *
   * @param {import('./availabilityBigTicketStore').AvailabilityBigTicketStoreState} state
   * @param {Object} value
   */
  setPreviouslyFocusedElement(state, value) {
    state.previouslyFocusedElement = value;
  },
  /**
   *
   * @param {import('./availabilityBigTicketStore').AvailabilityBigTicketStoreState} state
   * @param {number} slideoutId
   */
  setActiveSlideout(state, slideoutId) {
    state.activeSlideout = slideoutId;
  },
};

export const actions = {
  /**
   *
   * @param {import('vuex').ActionContext<import('./availabilityBigTicketStore').AvailabilityBigTicketStoreState, Object>} param0
   * @param {import('./availabilityBigTicketStore').fetchParams} param1
   */

  async fetchAvailability({ commit, state }, { lookupIds, zipCode }) {
    if (!zipCode) {
      throw new Error('zipCode is required');
    }
    if (!lookupIds) {
      throw new Error('lookupIds is required');
    }

    const url = buildUrl(lookupIds, zipCode);
    const objectKey = `${ zipCode }_${ lookupIds }`;

    if (isCached(state, objectKey)) {
      return;
    }
    const result = await get(url);

    commit('setData', { result, objectKey });
  },
};
